import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import * as React from 'react';
import { VERTICAL_URL } from 'settings';

import { useStyle } from './styles';

interface IProps {
  show: boolean;
}

function DesignReadjustIcon() {
  return (
    <svg width='15' height='14' viewBox='0 0 15 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.71223 0C6.95385 0 7.14973 0.195875 7.14973 0.4375C7.14973 0.679125 6.95385 0.875 6.71223 0.875L1.85596 0.875C1.37271 0.874999 0.980958 1.26675 0.980958 1.75L0.980958 12.25C0.980958 12.7332 1.37271 13.125 1.85596 13.125L12.3559 13.125C12.8392 13.125 13.2309 12.7332 13.2309 12.25V7.39369C13.2309 7.15206 13.4268 6.95619 13.6684 6.95619C13.9101 6.95619 14.1059 7.15206 14.1059 7.39369V12.25C14.1059 13.2165 13.3224 14 12.3559 14L1.85596 14C0.88946 14 0.105957 13.2165 0.105957 12.25L0.105957 1.75C0.105957 0.783501 0.889459 0 1.85596 0L6.71223 0Z'
        fill='#fff'
      />
      <path
        d='M10.1685 0L13.6685 0C13.9101 0 14.106 0.195876 14.106 0.4375V3.9375C14.106 4.17913 13.9101 4.375 13.6685 4.375C13.4268 4.375 13.231 4.17913 13.231 3.9375V1.49372L7.79063 6.93404C7.61978 7.1049 7.34277 7.1049 7.17191 6.93404C7.00106 6.76319 7.00106 6.48618 7.17191 6.31533L12.6122 0.875L10.1685 0.875C9.92683 0.875001 9.73096 0.679125 9.73096 0.4375C9.73096 0.195875 9.92683 0 10.1685 0Z'
        fill='#fff'
      />
    </svg>
  );
}

const OfferReadjustmentAlert = ({ show }: IProps) => {
  const classes = useStyle();
  if (!show) {
    return null;
  }

  return (
    <Alert
      severity='warning'
      action={
        <a className={classes.buttonAlert} href={`${VERTICAL_URL}/subscriptions/readjustment`}>
          <DesignReadjustIcon />
          Ir para reajustes
        </a>
      }
    >
      <AlertTitle>Aviso sobre contratos antigos</AlertTitle>
      Você está alterando o valor de novas assinaturas, onde contratos antigos não serão impactados. Deseja reajustar os antigos também?
    </Alert>
  );
};

export { OfferReadjustmentAlert };
